import { render, staticRenderFns } from "./BaseFormModal.vue?vue&type=template&id=6b9842ec&scoped=true&"
import script from "./BaseFormModal.vue?vue&type=script&lang=js&"
export * from "./BaseFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormModal.vue?vue&type=style&index=0&id=6b9842ec&lang=sass&scoped=true&"
import style1 from "./BaseFormModal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9842ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer})
